import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  expanderButtonAriaLabel: {
    defaultMessage: 'Toggle rate card expander',
    description: 'Aria label for the rate card expander button',
    id: '/rMUwx',
  },
  rateCardMissingServiceSelection: {
    defaultMessage: 'Select a service above to get a rate',
    description: 'Form instructions that tell the user to select a "service" value in order to receive a "rate" for that service',
    id: 'P/xuBm',
  },
  noCharge: {
    defaultMessage: "You won't be charged for test labels.",
    description: 'Text to display when there is no charge for printing a test label',
    id: 'o+nlmk',
  },
  upgradePromotionalBannerTitle: {
    defaultMessage: 'Save on this shipment by upgrading to a paid plan.',
    description: 'Header message for the promotional banner that encourages users to upgrade their plan in order to see more rates',
    id: 'LFHM0l',
  },
});
